/**
 * @generated SignedSource<<4e28605b793cb1d8af1b045a307e7efe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useFacilityRequiresCardOnFile_facility$data = {
  readonly club: {
    readonly supportsPublic: boolean;
  } | null | undefined;
  readonly publicBookingPermissionSet: {
    readonly requirePaymentCardOnFile: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useFacilityRequiresCardOnFile_facility";
};
export type useFacilityRequiresCardOnFile_facility$key = {
  readonly " $data"?: useFacilityRequiresCardOnFile_facility$data;
  readonly " $fragmentSpreads": FragmentRefs<"useFacilityRequiresCardOnFile_facility">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useFacilityRequiresCardOnFile_facility",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PublicBookingPermissionSet",
      "kind": "LinkedField",
      "name": "publicBookingPermissionSet",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "requirePaymentCardOnFile",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Club",
      "kind": "LinkedField",
      "name": "club",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "supportsPublic",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Facility",
  "abstractKey": null
};

(node as any).hash = "6d19aca5943ded3b2e289c534465ca08";

export default node;
